import { createAsyncThunk } from '@reduxjs/toolkit';
import { setNavItem, setNavReady } from '../init';
import { aflApi } from '../../api/afl-api';
import { changeRound } from './change-round';

export const changeSeason = createAsyncThunk(
    'nav/changeSeason',
    async ({ season, round, removeFinals }, { dispatch }) => {
        dispatch(setNavReady(false));

        dispatch(setNavItem({ navItem: 'season', value: season }));

        // Fetch rounds
        const { data: rounds } = await dispatch(
            aflApi.endpoints.getRounds.initiate({
                compseasonId: season.id,
                params: { pageSize: 50 }
            })
        );

        // sorting rounds by roundNumber to fix the incorrect ordering coming from API
        const roundsSorted = [...rounds].sort((roundA, roundB) =>
            roundA.roundNumber > roundB.roundNumber ? 1 : -1
        );

        // Set 'rounds' nav item in the state
        dispatch(setNavItem({ navItem: 'rounds', value: roundsSorted }));

        const roundsToFind = removeFinals
            ? roundsSorted.filter(PULSE.app.common.match.isNonFinalRound)
            : roundsSorted;

        // Set selected round
        const selectedRound =
            roundsToFind.find((item) =>
                round
                    ? item.id === parseInt(round.id)
                    : item.roundNumber === season.currentRoundNumber
            ) ?? roundsToFind[removeFinals ? roundsToFind.length - 1 : 0];

        await dispatch(
            changeRound({
                round: selectedRound,
                season: season
            })
        );
    }
);
